import { DISPLAY_TYPES } from './constants';
import CustomLinksTiles from '../components/CustomLinksTiles';
import CustomLinksLargeTiles from '../components/CustomLinksLargeTiles';

export const DISPLAY_TYPE_TO_COMPONENT = {
  [DISPLAY_TYPES.TILES]: CustomLinksTiles,
  [DISPLAY_TYPES.LARGE_TILES]: CustomLinksLargeTiles
};
